import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolNameSchema, ToolPolicy, ToolWeight, } from '../types.js';
const inputSchema = z.object({});
const outputSchema = z.object({
    proposals: z.array(z.object({
        id: z.uuid(),
        toolName: ToolNameSchema,
        status: z.enum(['PROPOSED', 'FAILED']),
        summary: z
            .string()
            .describe('One-line description of what was proposed. Inspect via the case to see full detail.'),
        input: z.unknown(),
        errorMessage: z.string().nullable(),
        proposedAt: z.iso
            .datetime()
            .describe('When the prior run proposed this action.'),
        ageMinutes: z.number().int(),
        caseChangedSince: z
            .boolean()
            .describe('True if the case has any new activity (interactions, status changes) since the proposal was created.'),
    })),
});
export const listPendingProposalsTool = {
    name: ToolName.ListPendingProposals,
    category: ToolCategory.Meta,
    weight: ToolWeight.Light,
    version: 2,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'List open heavy-tool proposals from prior runs, including proposals awaiting approval and failed proposals that a caseworker can retry or dismiss. Use this before adding a proposal so the same action is not presented twice. You cannot decide these proposals.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=list-pending-proposals.js.map